/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_DataInputs */

const en_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data ${i?.index}: ${i?.codec}`)
};

const fr_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Données ${i?.index}: ${i?.codec}`)
};

const de_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Daten ${i?.index}: ${i?.codec}`)
};

const it_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dati ${i?.index}: ${i?.codec}`)
};

const ru_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Данные ${i?.index}: ${i?.codec}`)
};

const es_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Datos ${i?.index}: ${i?.codec}`)
};

const zh_cn2_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数据 ${i?.index}: ${i?.codec}`)
};

const ja_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`データ ${i?.index}: ${i?.codec}`)
};

const hi_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`डेटा ${i?.index}: ${i?.codec}`)
};

const pt_pt2_audio_embed_export_stream_data = /** @type {(inputs: Audio_Embed_Export_Stream_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dados ${i?.index}: ${i?.codec}`)
};

/**
* | output |
* | --- |
* | "Data {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_data = /** @type {((inputs: Audio_Embed_Export_Stream_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_stream_data(inputs)
	if (locale === "de") return de_audio_embed_export_stream_data(inputs)
	if (locale === "it") return it_audio_embed_export_stream_data(inputs)
	if (locale === "ru") return ru_audio_embed_export_stream_data(inputs)
	if (locale === "es") return es_audio_embed_export_stream_data(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_stream_data(inputs)
	if (locale === "ja") return ja_audio_embed_export_stream_data(inputs)
	if (locale === "hi") return hi_audio_embed_export_stream_data(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_stream_data(inputs)
	return en_audio_embed_export_stream_data(inputs)
});